import { render, staticRenderFns } from "./PublicationForms.vue?vue&type=template&id=3eb1df87&scoped=true"
import script from "./PublicationForms.vue?vue&type=script&lang=js"
export * from "./PublicationForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb1df87",
  null
  
)

export default component.exports